import axios from "axios";
import * as React from "react";
import ContentArchiveResultApiModel from "../Models/ContentArchiveResultApiModel";

const apiUrl = "/api/ContentDataApi/GetContent";

interface IContentArchiveState {
    page: number;
    data: JSX.Element[];
    prevPage: number;
    nextPage: number;
    maxPages: number;
    currentYear: number;
}

interface IContentArchiveProps {
    targetId: string;
    database: string;
    language: string;
    showFiltersByYear: boolean;
    noContentFoundText: string;
}

export default class ContentArchive extends React.Component<IContentArchiveProps, IContentArchiveState> {
    private readonly maxContentPerPage: number = 15;
    constructor(props: IContentArchiveProps) {
        super(props);
        const date = new Date();
        const year = date.getFullYear();
        this.state = {
            currentYear: year,
            data: new Array<JSX.Element>(),
            maxPages: 0,
            nextPage: 2,
            page: 1,
            prevPage: 0,
        };
        this.onNextClick = this.onNextClick.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
        this.changeYearOnClick = this.changeYearOnClick.bind(this);
        this.getContent(1, year);
    }

    public render() {
        return (
            <div className="content-archive">
                {this.renderFilters()}
                <ul className="content-arcive-list">
                    {this.state.data}
                </ul>
                <div className="archive-paging">
                    {this.renderPrevPageButton()}
                    <span className="curr-page-btn">{this.state.page}</span>
                    {this.renderNextPageButton()}
                </div>
            </div>
        );
    }

    private changeYearOnClick(year: number) {
         this.setState((state, props) => ({
             currentYear: year,
             nextPage: 2,
             page: 1,
             prevPage: 0,
         }));
         this.getContent(1, year);
    }

    private renderFilters() {
        const date = new Date();
        const years = [];
        const year = date.getFullYear();

        // Last 6 years will be displayed
        for (let i = year; i > year - 6; i--) {
            years.push(i);
        }

        if (this.props.showFiltersByYear) {
            const result = years.map((content, i) =>
                             (
                                <span
                                    key={i}
                                    onClick={() => (this.changeYearOnClick(content))}
                                    className={`filter-btn ${content === this.state.currentYear ? "selected" : ""}`}
                                >
                                    {content}
                                </span>
                            ));
            return (
                    <div className="year-filters">
                        {result}
                        </div>
                    );
        }
    }
    private renderPrevPageButton() {
        if (this.state.prevPage >= 1) {
            return (
                <span className="prev-page-btn" onClick={this.onPrevClick}>
                    {this.state.prevPage}
                </span>
            );
        }
        return "";
    }
    private renderNextPageButton() {
        if (this.state.nextPage > 1 && this.state.nextPage <= this.state.maxPages) {
            return (
                <span className="next-page-btn" onClick={this.onNextClick}>
                    {this.state.nextPage}
                </span>
            );
        }
        return "";
    }
    private getContent(pageNumber: number, year: number) {
        // If we are not displaying years, we want all content
        if (!this.props.showFiltersByYear) {
            year = -1; // get content without depending on publishing year
        }

        /* tslint:disable-next-line:max-line-length */
        const getUrl = `${apiUrl}?page=${pageNumber}&id=${this.props.targetId}&language=${this.props.language}&database=${this.props.database}&year=${year}`;

        axios.get(getUrl).then((response) => {
            if (response && response.data) {
                   return this.populateArchiveList(response.data.result);
            } else {
                console.error("Unable to get data for content archive");
                return "";
            }
        });
    }
    private populateArchiveList(result: ContentArchiveResultApiModel) {
        let archiveList = null;
        if (result.totalContentCount === 0) {
            archiveList = [<p key={1}>{this.props.noContentFoundText}</p>];
        } else {
            archiveList = result.contentData.map((content) =>
                (
                    <li key={content.id}>
                        <span className="date">{content.date}</span>
                        <a href={content.pageUrl}>{content.title}</a>
                    </li>
                ),
            );
        }

        const max = Math.ceil(result.totalContentCount / this.maxContentPerPage);
        this.setState({
            data: archiveList,
            maxPages: max,
        });
    }
    private incrementPageNumbering(increment: boolean) {
        const index = increment ? 1 : -1;
        const pageNumber = this.state.page + index;
        this.getContent(pageNumber, this.state.currentYear);
        if (pageNumber <= this.state.maxPages) {
            this.setState({ page: pageNumber, prevPage: pageNumber - 1, nextPage: pageNumber + 1 });
        }
    }
    private onNextClick() {
        this.incrementPageNumbering(true);
    }
    private onPrevClick() {
        this.incrementPageNumbering(false);
    }
}
